import React, { createContext } from 'react';

import {
  BillingAddressErrorType,
  PhoneNumberDataErrorType,
  VippsPaymentDataErrorType,
  VippsPaymentDataType,
} from 'types/checkout';
import { MemberAsCompanyType, MemberCompanyInfoErrorType } from 'types/member';

type BillingAddress = {
  address: string;
  postCode: string;
  city: string;
  country: string;
  addressTwo?: string;
  invoiceReference?: string;
};

const PaymentFormContext = createContext({
  selectedPayementMethod: '',
  cardError: '',
  paymentProviders: [] as string[],
  memberCompanyInfo: {} as MemberAsCompanyType,
  memberCompanyInfoErrors: {} as MemberCompanyInfoErrorType,
  vippsPaymentData: {} as VippsPaymentDataType,
  vippsPaymentDataErrors: {} as VippsPaymentDataErrorType,
  billingAddressData: {} as BillingAddress,
  shouldAddBillingAddress: false,
  memberPhoneNumber: '',
  billingAddressErrors: {} as BillingAddressErrorType,
  phoneNumberDataErrors: {} as PhoneNumberDataErrorType,
  onChangeVippsPhoneNumber: (phoneNumber: string) => {
    console.log(phoneNumber);
  },
  onChangeMethod: (payementMethodId: string) => {
    console.log(payementMethodId);
  },
  onChangeMemberAsCompany: (isCompany: boolean) => {
    console.log(isCompany);
  },
  onChangeMemberCompanyInfo: (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e);
  },
  onChangeBillingAddressData: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
  ) => {
    console.log(e);
  },
  onChangeShouldAddBillingAddress: (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e);
  },
  onChangePhoneNumber: (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e);
  },
});

const PaymentFormProvider = ({
  children,
  payementMethod,
  cardError,
  paymentProviders,
  memberCompanyInfo,
  memberCompanyInfoErrors,
  vippsPaymentData,
  vippsPaymentDataErrors,
  billingAddressData,
  shouldAddBillingAddress,
  billingAddressErrors,
  memberPhoneNumber,
  phoneNumberDataErrors,
  handleChangeVippsPhoneNumber,
  handleChangePaymentMethod,
  handleChangeMemberAsCompany,
  handleChangeMemberCompanyInfo,
  handleChangeBillingAddressData,
  handleShouldAddBillingAddress,
  handlePhoneNumberChange,
}: {
  children: React.ReactNode;
  payementMethod: string;
  cardError: string;
  paymentProviders: string[];
  memberCompanyInfo: MemberAsCompanyType;
  memberCompanyInfoErrors: MemberCompanyInfoErrorType;
  vippsPaymentData: VippsPaymentDataType;
  vippsPaymentDataErrors: VippsPaymentDataErrorType;
  billingAddressData: BillingAddress;
  shouldAddBillingAddress: boolean;
  billingAddressErrors: BillingAddressErrorType;
  memberPhoneNumber: string;
  phoneNumberDataErrors: PhoneNumberDataErrorType;
  handleChangeVippsPhoneNumber: (phoneNumber: string) => void;
  handleChangePaymentMethod: (payementMethodId: string) => void;
  handleChangeMemberAsCompany: (isCompany: boolean) => void;
  handleChangeMemberCompanyInfo: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeBillingAddressData: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
  ) => void;
  handleShouldAddBillingAddress: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handlePhoneNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <PaymentFormContext.Provider
      value={{
        selectedPayementMethod: payementMethod,
        cardError,
        paymentProviders,
        memberCompanyInfo,
        memberCompanyInfoErrors,
        vippsPaymentData,
        vippsPaymentDataErrors,
        billingAddressData,
        shouldAddBillingAddress,
        billingAddressErrors,
        memberPhoneNumber: memberPhoneNumber,
        phoneNumberDataErrors,
        onChangeVippsPhoneNumber: handleChangeVippsPhoneNumber,
        onChangeMethod: handleChangePaymentMethod,
        onChangeMemberAsCompany: handleChangeMemberAsCompany,
        onChangeMemberCompanyInfo: handleChangeMemberCompanyInfo,
        onChangeBillingAddressData: handleChangeBillingAddressData,
        onChangeShouldAddBillingAddress: handleShouldAddBillingAddress,
        onChangePhoneNumber: handlePhoneNumberChange,
      }}
    >
      {children}
    </PaymentFormContext.Provider>
  );
};

export { PaymentFormContext, PaymentFormProvider };
